import { FONTS } from 'common/constants';
import React from 'react';
import styled, { css } from 'styled-components';

export const Container = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  height: 100%;
  overflow-y: scroll;
  padding: 120px 80px;
  position: relative;
  background-color: #fff;
`;

export const ImageWrap = styled.div`
  img {
    width: 100%;
    max-width: 500px;
    height: auto;
  }
  justify-content: center;
  display: flex;
  width: 100%;
`;

export const LeftContent = styled.div`
  padding: 0px 30px 30px 30px;
  background-color: #f3f3f0;
  margin: 30px 100px 30px 0;
`;
export const RightContent = styled.div`
  width: 40%;
  & img {
    width: 100%;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 25%;
  min-width: 250px;
`;

export const ProductNameBox = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  font-family: ${FONTS.medium};
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  text-align: center;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TabsWrapper = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 4px;
  width: 100%;
`;
export const Tabs = styled.div<{ active?: boolean }>`
  cursor: pointer;
  padding: 10px;
  font-family: ${FONTS.medium};
  font-size: 18px;
  line-height: 1;
  width: 50%;
  text-align: center;
  ${({ active, theme }) =>
    active &&
    css`
      background: ${theme.colors.primary};
      color: white;
    `}
`;

export const DetailsContentWrapper = styled.div``;
export const ContentHeader = styled.h3`
  font-family: ${FONTS.medium};
  font-size: 30px;
`;
export const BodyContent = styled.p`
  line-height: 1.5;
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ListWrapper = styled.ul`
  margin: 30px 0;
  padding: 0;
  padding-left: 15px;
  font-family: ${FONTS.medium};
  font-size: 18px;
  list-style: none;
  position: relative;
`;

export const ListItem = styled.li`
  margin-bottom: 10px;
  padding-left: 15px;
  line-height: 1;
  position: relative;
  &:before {
    content: '';
    border-radius: 50px;
    background-color: ${({ theme }) => theme.colors.primary};
    width: 10px;
    height: 10px;
    position: absolute;
    top: 40%;
    left: -15px;
    transform: translateY(-50%);
  }
`;

export const ContactButton = styled.a`
  background: ${({ theme }) => theme.colors.bodyText};
  border-radius: 4px;
  cursor: pointer;
  color: white;
  display: inline-block;
  margin-top: 30px;
  padding: 10px 30px;
  text-decoration: none;
`;

export const TechnicalDetails = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin-top: 90px;
`;

export const TechnicalDetailsLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: 500;
`;
